import {
  TextReplaceForm,
  type TextReplaceFormValues,
  isRuleApplyToAllPages,
} from '@carboncopyco/editor-ui';
import type { ITextReplaceRule } from '@carboncopyco/types';
import {
  useEditor,
  useEditorMetadata,
} from '../../../context/EditorSdkProvider';
import type { IFindAndReplaceRuleState } from '../types';

export type EditControlsProps = Pick<
  IFindAndReplaceRuleState<ITextReplaceRule>,
  'onSubmit' | 'rule' | 'rules' | 'onCancel' | 'onFocus' | 'autoFocus'
>;

export const EditControls = ({
  onSubmit,
  rule,
  onCancel,
  onFocus,
  autoFocus,
  rules,
}: EditControlsProps) => {
  const editorSdk = useEditor();
  const { location } = useEditorMetadata();
  const { decodedUrl } = location ?? {};
  const { options } = rule;

  const createRule = ({ oldValue, newValue, options }: TextReplaceFormValues) =>
    onSubmit({
      ...rule,
      oldValue,
      newValue,
      options,
    });

  return (
    <TextReplaceForm
      initialValues={rule}
      onSubmit={createRule}
      submitText="Save"
      onCancel={onCancel}
      onFocus={onFocus}
      autoFocus={autoFocus}
      unlimitedText
      advancedSettings={{
        location: {
          decodedUrl: !isRuleApplyToAllPages(options?.applyOnUrls)
            ? options?.applyOnUrls?.[0]
            : decodedUrl,
        },
      }}
      onLearnMoreClick={editorSdk.openUrlLink}
      rules={rules}
    />
  );
};
